import axios from '@/libs/api.request'

export const login = ({ userName, password, captchaId, verify }) => {
  return axios.request({
    url: '/login',
    params: {
      username: userName,
      password: password,
      verify: verify,
      captchaId: captchaId
    },
    method: 'post'
  })
}

export const getUserInfo = (token) => {
  return axios.request({
    url: '/getInfo',
    params: {
      token
    },
    method: 'get'
  })
}

export const getInitCaptcha = () => {
  return axios.request({
    url: '/initCaptcha',
    method: 'get'
  })
}

export const getInitShortMessage = (email) => {
  return axios.request({
    url: '/initShortMessage',
    params: {
      email: email
    },
    method: 'get'
  })
}

export const register = (data) => {
  return axios.request({
    url: '/register',
    data: data,
    method: 'post'
  })
}

export const logout = () => {
  return axios.request({
    url: '/logout'
  })
}

export const getUnreadCount = () => {
  return axios.request({
    url: 'messageDetail/getByStatusCount',
    method: 'get'
  })
}

export const getMessage = () => {
  return axios.request({
    url: 'message/init',
    method: 'get'
  })
}

export const getContentByMsgId = msg_id => {
  return axios.request({
    url: 'message/content',
    method: 'get',
    params: {
      msg_id
    }
  })
}

export const hasRead = msg_id => {
  return axios.request({
    url: 'message/has_read',
    method: 'post',
    data: {
      msg_id
    }
  })
}

export const removeReaded = msg_id => {
  return axios.request({
    url: 'message/remove_readed',
    method: 'post',
    data: {
      msg_id
    }
  })
}

export const restoreTrash = msg_id => {
  return axios.request({
    url: 'message/restore',
    method: 'post',
    data: {
      msg_id
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js